import {PersonReminder, PersonReminderRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";
import {SoftChip} from "../../../../components/kit";

export const PersonReminderListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<PersonReminder> = {
		title: "Recordatorios de empleados",
		onClick: "/app/admin/employee/reminder",
		headers: [
			{title: "Texto", width: "80%"},
			{title: "Estado"},
		],
		decorator: (bean: PersonReminder) => (
			<>
				<TableCell style={{
					color: bean.dismissed ? COLOR_DISMISSED : "", whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis",
				}}>
					{bean.content}
				</TableCell>
				<TableCell>
					{bean.disabled ? <SoftChip tone="neutral" label="Desactivado"/> : <SoftChip tone="success" label="Activo"/>}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PersonReminderRestControllerApiFactory);
			return ctrl.pagePersonReminder(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};